import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLAYROOM_ACHIEVEMENTS_SECTION_KEY } from "../constants";
var PTTranslations = /*#__PURE__*/_defineProperty({}, PLAYROOM_ACHIEVEMENTS_SECTION_KEY, {
  PAS_TITLE: 'Medalhas',
  PAS_DESCRIPTION: 'Veja suas medalhas ganhas ou as medalhas que você ainda pode desbloquear durante sua aprendizagem.',
  PAS_GOTO_MY_COURSES: 'Ir a cursos',
  PAS_HELP_SECTION_TITLE: 'Como é que ganho pontos depois de ganhar medalhas?',
  PAS_ERROR_VIEW_TITLE: 'Os dados não foram carregados corretamente',
  PAS_ERROR_VIEW_DESCRIPTION: 'Por favor recarregue a página'
});
export default PTTranslations;